export default __webpack_public_path__ + "static/Lsa_banner-f8a5ef2ab866dce930f872490fea0042.jpg";